import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const STATES = ["", "pending", "countered", "accepted", "declined", "declined_by_member"];

export default function HQAfterHours() {
  const [state, setState] = useState("");
  const [items, setItems] = useState([]);
  const [openId, setOpenId] = useState(null);

  const load = () => api.get(`/hq/after-hours${state ? `?state=${state}` : ""}`).then((r) => setItems(r.data || []));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [state]);

  return (
    <div className="p-6" data-testid="hq-after-hours">
      <p className="overline">After-hours</p>
      <h1 className="font-display text-3xl tracking-tighter mb-6">After-Hours Operations</h1>
      <p className="text-xs text-cream/60 mb-4">HQ primarily observes. Do not interfere unless operationally necessary.</p>
      <div className="flex gap-2 mb-4 flex-wrap">
        {STATES.map((s) => (
          <button key={s || "all"} data-testid={`hq-ah-filter-${s || "all"}`} onClick={() => setState(s)}
                  className={`chip text-[10px] ${state === s ? "border-gold text-gold bg-gold/5" : ""}`}>{s || "all"}</button>
        ))}
      </div>
      <div className="space-y-3">
        {items.length === 0 && <div className="border border-cream/10 p-4 text-center text-cream/50 text-xs" data-testid="hq-ah-empty">No after-hours requests in this state.</div>}
        {items.map((a) => (
          <div key={a.id} className="border border-cream/10 p-4" data-testid={`hq-ah-${a.id}`}>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-cream">{a.member_name} → {a.studio_name}</p>
                <p className="text-[10px] uppercase tracking-[0.2em] text-cream/50">{a.service_name} · ${a.service_price} · proposed {new Date(a.proposed_time).toLocaleString()}</p>
                {a.counter_time && <p className="text-[10px] text-gold">Countered {new Date(a.counter_time).toLocaleString()}</p>}
              </div>
              <span className={`chip text-[10px] ${a.status === "accepted" ? "border-emerald-400/40 text-emerald-300" : a.status === "declined" || a.status === "declined_by_member" ? "border-red-400/40 text-red-300" : ""}`}>{a.status.replace(/_/g, " ")}</span>
            </div>
            <button data-testid={`hq-ah-toggle-${a.id}`} onClick={() => setOpenId(openId === a.id ? null : a.id)}
                    className="mt-2 text-[10px] uppercase tracking-[0.2em] text-cream/50 hover:text-gold">
              {openId === a.id ? "Hide audit trail" : "Show audit trail"}
            </button>
            {openId === a.id && (
              <div className="mt-2 border border-cream/10 p-3 space-y-1" data-testid={`hq-ah-trail-${a.id}`}>
                {(a.audit_log || []).map((e, i) => (
                  <div key={i} className="flex gap-3 text-[10px]">
                    <span className="font-mono text-gold/70 w-32">{new Date(e.at).toLocaleString()}</span>
                    <span className="text-cream/70">{e.actor_role}: {e.action}</span>
                    {e.meta && Object.keys(e.meta).length > 0 && <span className="text-cream/40">· {JSON.stringify(e.meta)}</span>}
                  </div>
                ))}
                {a.booking_id && <p className="text-[10px] text-emerald-300 mt-2">→ Converted to booking {a.booking_id.slice(0, 8)}…</p>}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
